import { tss } from "tss-react";
import { spacing, panelHeaderHeight, boxShadow } from "./common";

var useStyles = tss.create({
    topRoot: {
        position: "absolute",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#a0a0a0de",
        left: 300,
        width: "calc(100% - 300px)",
        height: panelHeaderHeight,
        transition: "height 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms, width 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms",
        //boxShadow: "inset 0px 10px 12px #0000002b",
        boxShadow: boxShadow,

        userSelect: "none",
        background: 'rgba(34, 45, 69, 0.9)',
        borderTop: '1px solid rgba(255,255,255,.05)',
        " &.light-theme": {
            background: 'rgba(32,32,32,.6)'
        }
    },
    cell: {
        display: "inline-flex",
        alignItems: "center",
        height: "100%",
        overflow: "hidden",
    },
    button: {
        minWidth: 20,
        padding: "5px 5px",
        width: 24,
        height: 24,
        borderRadius: 0,
    },
    toolIcon: {
        width: 24,
        height: 24,
    },
    directionMenu: {},
    menuItem: {
        width: 56,
    },
    dropDownIcon: {
        width: 20,
        height: 20,
        position: "relative",
        top: 10,
        marginLeft: -10,
        transform: "rotate(-45deg)",
        color: "white",
    },
    toolIconShiftLeft: {
        width: 24,
        height: 24,
        marginLeft: 8,
        color: "white",
    },
    firstGroup: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "flex-start",
        width: 4 * spacing,
        flexGrow: 0,
        flexShrink: 0,
    },
    secondGroup: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: 23 * spacing,
        flexGrow: 1,
        flexShrink: 0,
    },
    thirdGroup: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "flex-end",
        //width: 9 * spacing,
        flexGrow: 0,
        flexShrink: 0,
    },
    divider: {
        backgroundColor: "white",
        display: "inline-flex",
        alignItems: "center",
        height: 42,
    },
});

export default useStyles;
